import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedDataService {
  private dataSource = new BehaviorSubject<any>(null);
  data$ = this.dataSource.asObservable();

  // Guardar en memoria y localStorage
  setData(key: string, value: any): void {
    this.dataSource.next(value);
    localStorage.setItem(key, JSON.stringify(value));
  }

  getData(key: string): any {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  }

  removeData(key: string): void {
    localStorage.removeItem(key);
  }
  
  // Leer (por ejemplo, tras un reload)
  loadFromStorage(key: string): void {
    const stored = localStorage.getItem(key);
    if (stored) this.dataSource.next(JSON.parse(stored));
  }
}
